import { gql } from "@apollo/client";
import { ImageFragment } from "../../fragments/image";

export const QUERY_LEARN_PAGE = gql`
  query LearnPage {
    learnPage {
      data {
        attributes {
          learnHighlight {
            image {
              data {
                ...ImageFragment
              }
            }
            title
            description
          }
          emptyInProgressCoursesMessage
          emptyCompletedCoursesMessage
          emptyCoursesMessage
          markLessonAsCompleteButton {
            markAsCompleteLabel
            completedLabel
          }
          markCourseAsCompleted {
            markAsCompleteLabel
            completedLabel
          }
          contentTemplateLabels {
            downloadableContentLabel
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_COURSE_FEEDBACK_PAGE = gql`
  query courseFeedbackPage {
    learnPage {
      data {
        attributes {
          markCourseAsCompleted {
            completedLabel
          }
          feedbackSection {
            title
            description
            submitYourFeedback
            enterYourFeedback
            sendFeedback
          }
          modalLeavePage {
            title
            description
            confirmButton
            cancelButton
          }
        }
      }
    }
  }
`;
